export const CHROMAL_DELTAS_MS = [
  35_000, 30_000, 25_000, 20_000, 15_000, 10_000, 5_000, 0, -5_000, -10_000, -15_000,
] as const;

export function getChromalDelta(levelsCleared: number): number {
  if (!Number.isInteger(levelsCleared) || levelsCleared < 0 || levelsCleared > 10) {
    throw new RangeError('Chromal levels cleared must be an integer from 0 through 10.');
  }
  return CHROMAL_DELTAS_MS[levelsCleared];
}
